<template>
  <div class="categoryItem">
    <swiper v-if="cateItem && cateItem.bannerList && cateItem.bannerList.length" id="swiperBanner" :options="bannerSwiper">
      <swiper-slide v-for="(item, index) of cateItem.bannerList" :key="index">
        <img :src="item.img_path" @error="function (event) {let img = event.srcElement;img.src = errorImg; img.onerror = null;}">
        <div :path="item.ad_target + (item.ad_target.indexOf('?') >= 0 ? '&' : '?') + 'sorce=1'" :username="'gh_5d4bb8e18b8b'" class="slide_cl_xcx" v-if="isWx && (item.ad_type == 7 || item.ad_type == 8)"></div>
      </swiper-slide>
    </swiper>
    <div class="featuredads" v-if="cateItem && cateItem.advertiseList && cateItem.advertiseList.length">
      <div style="position:relative;" v-for="(item, index) of cateItem.advertiseList" @click="bannerClick(item, index, markButtonCodeData.buttonCode ? markButtonCodeData.buttonCode : '')">
        <img :src="item.img_path" @error="function (event) {let img = event.srcElement;img.src = errorImg; img.onerror = null;}">
        <div :path="item.ad_target + (item.ad_target.indexOf('?') >= 0 ? '&' : '?') + 'sorce=7'" :username="'gh_5d4bb8e18b8b'" class="slide_cl_xcx" v-if="isWx && (item.ad_type == 7 || item.ad_type == 8)"></div>
      </div>
    </div>
  </div>
</template>

<script>
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import {
  isWeixin,
  bannerClick
} from '../../assets/common/js/config'
import Vue from 'vue'

Vue.use(VueAwesomeSwiper /* { default global options } */)
export default {
  components: {
    swiper: VueAwesomeSwiper.swiper,
    swiperSlide: VueAwesomeSwiper.swiperSlide
  },
  props: {
    cateItem: Object,
    markButtonCodeData: Object | Array
  },
  name: 'category_actItem',
  data () {
    var that = this
    return {
      isWx: isWeixin() ? 1 : 0,
      bannerSwiper: {
        loop: true,
        autoplay: {
          disableOnInteraction: false
        },
        initialSlide: 0,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        spaceBetween: 10,
        slidesOffsetAfter: 20,
        watchOverflow: true,
        pagination: {
          el: '#bannerSwiperPagination',
          // clickable: true,
          type: 'bullets'
        },
        on: {
          slideChangeTransitionStart: function () {
            that.activeIndex = this.realIndex
          },
          click: function () {
            var activeIndex = this.realIndex
            that.bannerClick(that.cateItem.bannerList[activeIndex], activeIndex, that.markButtonCodeData.buttonCode ? that.markButtonCodeData.buttonCode : '')
          }
        }
      },
    }
  },
  methods: {
    bannerClick: function (items, index, flowArea) {
      bannerClick(items, index, flowArea, this, () => {
        this.dataCollection(items, index, flowArea)
      }, this.markButtonCodeData.buttonCode ? this.markButtonCodeData.buttonCode : '', {point: this.markButtonCodeData})
    },
    dataCollection (items, index, flowArea) {
      let params = {
        flowArea_var: flowArea, // 区域
        position_var: index, // 坑位
        flowName_var:
          flowArea == '热门直播' ? items.name : items.ad_title || '', // 流量位名称
        productName_var: flowArea == '热门直播' ? '' : items.name || '' // 商品名称
      }

      // 首页-流量位-埋点事件
      gio('track', 'flowLocationClick', params)
      // 首页-流量位-区域-转化变量
      gio('evar.set', 'flowArea_evar', flowArea)
      // 首页-流量位-区域-坑位-转化变量
      let value = flowArea == '热门直播' ? items.name : items.ad_title || ''
      gio('evar.set', 'flowName_evar', value)
    },
  }
}
</script>

<style scoped lang="scss">
.categoryItem {
  margin: 0.1rem 0.11rem;
  .swiper-container {
    width: 100%;
    /*height: 0.8rem;*/
    margin: 0 0 0.1rem;
    .swiper-wrapper {
      padding: 0 0.1rem;
      box-sizing: border-box;
      .swiper-slide {
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
  .featuredads {
    margin: 0.1rem 0;
    border-radius: 0.1rem;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/category/category_actItem.vue